@if (isCallActive()) {
  <div class="fixed bottom-4 right-4 z-[100] cursor-move" cdkDrag>
    <button
      type="button"
      (click)="toggleMinimize()"
      class="relative -top-2 right-2 flex h-6 w-6 items-center justify-center rounded-full border border-gray-200 bg-gray-900 text-white dark:border-gray-600"
      [attr.aria-label]="isMinimized ? 'Maximize call controls' : 'Minimize call controls'"
    >
      <span class="text-xs">{{ isMinimized ? '+' : '−' }}</span>
    </button>

    @if (!isMinimized) {
      <div class="min-w-[320px] rounded-2xl bg-gray-900 p-6 text-white shadow-lg">
        <div class="mb-3 flex items-center justify-between">
          <div class="flex items-center gap-2">
            <span
              class="h-2 w-2 rounded-full"
              [class.bg-yellow-500]="callState.status === 'connecting' || callState.status === 'ringing'"
              [class.bg-green-500]="callState.status === 'connected'"
              [class.bg-orange-500]="callState.isOnHold"
              [class.animate-pulse]="callState.status === 'ringing'"
            ></span>
            <span class="text-sm font-medium">{{ getStatusLabel() }}</span>
            @if (callState.provider) {
              <span class="rounded bg-gray-700 px-1.5 py-0.5 text-[10px] uppercase text-gray-300">
                {{ callState.provider }}
              </span>
            }
          </div>
          @if (isCallConnected() && callState.duration) {
            <span class="font-mono text-xs">{{ formatDuration(callState.duration) }}</span>
          }
        </div>

        @if (callState.callerInfo && (isCallConnected() || isInboundRinging())) {
          <div class="mb-3 border-b border-gray-700 pb-3 text-center">
            @if (callState.callerInfo.name) {
              <p class="text-sm font-medium">{{ callState.callerInfo.name }}</p>
            }
            @if (callState.callerInfo.email) {
              <p class="text-xs text-gray-300">{{ callState.callerInfo.email }}</p>
            }
            <p class="text-xs text-gray-300">{{ callState.callerInfo.phoneNumber }}</p>
          </div>
        }

        @if (callState.status === 'error' && callState.error) {
          <div class="mb-3 rounded border border-red-400/50 bg-red-950/40 p-2 text-xs text-red-200">
            {{ callState.error }}
          </div>
        }

        <div class="flex items-center justify-center gap-3">
          @if (isInboundRinging()) {
            <button
              type="button"
              class="flex-1 rounded-lg bg-green-600 px-3 py-2 text-sm font-medium hover:bg-green-700"
              (click)="acceptIncoming()"
            >
              Accept
            </button>
            <button
              type="button"
              class="flex-1 rounded-lg bg-red-600 px-3 py-2 text-sm font-medium hover:bg-red-700"
              (click)="declineIncoming()"
            >
              Decline
            </button>
          } @else {
            <button
              type="button"
              class="flex-1 rounded-lg border border-gray-600 px-3 py-2 text-sm hover:bg-gray-800"
              [class.bg-red-900/40]="callState.isMuted"
              (click)="toggleMute()"
            >
              {{ callState.isMuted ? 'Unmute' : 'Mute' }}
            </button>
            @if (showHoldButton()) {
              <button
                type="button"
                class="flex-1 rounded-lg border border-gray-600 px-3 py-2 text-sm hover:bg-gray-800"
                [class.bg-orange-900/40]="callState.isOnHold"
                (click)="toggleHold()"
              >
                {{ callState.isOnHold ? 'Resume' : 'Hold' }}
              </button>
            }
            <button
              type="button"
              class="flex-1 rounded-lg bg-red-600 px-3 py-2 text-sm font-medium hover:bg-red-700"
              (click)="hangup()"
            >
              Hang Up
            </button>
          }
        </div>
      </div>
    } @else {
      <div class="rounded-2xl bg-gray-900 px-6 py-3 shadow-lg">
        <icon-phone class="h-5 w-5 text-white"></icon-phone>
      </div>
    }
  </div>
}
